import { render, staticRenderFns } from "./HourlyBarChart.vue?vue&type=template&id=4bb4799c&"
import script from "./HourlyBarChart.vue?vue&type=script&lang=js&"
export * from "./HourlyBarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./HourlyBarChart.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bb4799c')) {
      api.createRecord('4bb4799c', component.options)
    } else {
      api.reload('4bb4799c', component.options)
    }
    module.hot.accept("./HourlyBarChart.vue?vue&type=template&id=4bb4799c&", function () {
      api.rerender('4bb4799c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/Dashboard/HourlyBarChart.vue"
export default component.exports